import { Grid, CircularProgress, Typography, Button, Dialog } from "@mui/material";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { grey, orange } from '@mui/material/colors';
import moment from "moment";
import 'moment-timezone';
import styles from './DetailsModalChart.module.scss';
import { Modal } from "../../modal";
import { LineChartCard } from "../sensorChartCard";
import { AlarmsCardModal } from "../alarmsCardModal";
import { useState } from 'react';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import { MapModal } from "../../vehicleCard/mapModal";
import { TrackerRelationshipsService } from "../../../services/trackerRelationships";
import { NotificationManager } from "react-notifications";
import CloseIcon from '@mui/icons-material/Close';
import Fade from '@mui/material/Fade';
moment.tz.setDefault('America/Sao_Paulo');

export const DetailsModalChart = ({ open, handleOnClose, dataToChartLine, alarms, loadingSensorData, cardId, lastUpdate }) => {
    const [openAlarms, setOpenAlarms] = useState(false);
    const [chartKey, setChartKey] = useState(0);
    const [openModalMap, setOpenModalMap] = useState(false);
    const [latlngData, setLatlngData] = useState([]);
    const [datasPerDay, setDatasPerDay] = useState([]);
    const [alarmsPerDay, setAlarmsPerDay] = useState([]);
    const [latLongTimer, setLatLongTimer] = useState();
    const [lastUpdateDetails, setLastUpdateDetails] = useState(null);
    const trackerRelationshipsService = new TrackerRelationshipsService();


    const getLatLong = (cardId) => {
        trackerRelationshipsService.getLatLong(cardId).then(res => {
            setLatlngData(res.data);
        }).catch(err => {
            NotificationManager.error('Erro obtendo posições do veículo.', "", 3000);
            setLatLongTimer(clearInterval(latLongTimer));
        });
    };

    const handleOpenModalMap = (cardId) => {
        getLatLong(cardId);
        setOpenModalMap(true);
    };

    const handleOnCloseMapModal = () => {
        setOpenModalMap(false);
        setLatLongTimer(clearInterval(latLongTimer));
    };


    const handleOpenModalAlarms = () => {
        setChartKey(prevKey => prevKey + 1);
        setOpenAlarms(true);
    };

    const handleCloseModalAlarms = () => {
        setChartKey(prevKey => prevKey + 1);
        setOpenAlarms(false);
    };

    const theme = createTheme({
        palette: {
            primary: grey,
        },
    });

    const mapTheme = createTheme({
        palette: {
            primary: {
                main: orange[500],
            },
        },
    });


    const themeButton = createTheme({
        palette: {
            primary: grey,
        },
    });

    return (
        <>
            {
                openAlarms !== true ? (
                    <Modal onClose={handleOnClose} open={open} width={'100%'} height={'100%'} type={'farm'}>
                        <div>
                            {loadingSensorData === false ?
                                <Grid container sx={{ minHeight: '100%' }}>

                                    <div className={styles.divCardChartPortAndAC} style={{ marginTop: !openAlarms ? '-80px' : '-110px', height: !openAlarms ? '10vh' : '15vh' }}>
                                        <LineChartCard
                                            dataToChart={datasPerDay.length === 0 ? dataToChartLine : datasPerDay}
                                            type={"portAndAC"}
                                        />
                                    </div>


                                    <div className={styles.divCardChart} style={{ marginTop: !openAlarms ? '30px' : '-30px', height: !openAlarms ? '70vh' : '58vh' }}>

                                        <div id="legend-container" className={styles.divLegend} style={{ height: '15px' }}>

                                        </div>
                                        <LineChartCard
                                            dataToChart={datasPerDay.length === 0 ? dataToChartLine : datasPerDay}
                                            key={chartKey}
                                            type={"all"}
                                        />
                                    </div>

                                    <Grid container spacing={1} sx={{ marginLeft: '550px' }}>
                                        <Grid item xs={6} sx={{ marginTop: '15px' }}>
                                            <ThemeProvider theme={theme}>
                                                <Button onClick={handleOpenModalAlarms} endIcon={<ExpandMoreRoundedIcon />} variant="outlined" color='primary' sx={{
                                                    height: '35px', width: '145px', fontSize: '14px', backgroundColor: '#9e9e9e', color: 'white', '&:hover': {
                                                        backgroundColor: 'gray',
                                                    },
                                                }}>
                                                    ALARMES
                                                </Button>
                                            </ThemeProvider>
                                        </Grid>

                                        <Grid item xs={6} sx={{ marginTop: '15px' }}>
                                            <ThemeProvider theme={mapTheme}>
                                                <Button onClick={(e) => handleOpenModalMap(cardId)} variant="outlined" color='primary' endIcon={<LocationOnRoundedIcon />} sx={{
                                                    height: '35px', width: '145px', fontSize: '12px', backgroundColor: 'rgb(223, 138, 12)', color: 'white', '&:hover': {
                                                        backgroundColor: 'rgba(223, 138, 12, 0.8)',
                                                    },
                                                }}>
                                                    VER NO MAPA
                                                </Button>
                                            </ThemeProvider>
                                        </Grid>

                                    </Grid>
                                    <div style={{ width: "100%" }}>
                                        <Typography
                                            style={{ float: 'right', paddingTop: '5px', marginTop: 'auto', fontSize: '13px', marginRight: '50px' }}
                                            component="span"
                                            variant="body2"
                                        >

                                            Atualizado em {lastUpdateDetails === null ? lastUpdate : lastUpdateDetails}
                                        </Typography>
                                    </div>

                                </Grid>

                                :
                                <CircularProgress
                                    size={80}
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: `${-80 / 2}px`,
                                        marginLeft: `${-80 / 2}px`
                                    }}
                                />
                            }
                            {openAlarms === true ?
                                <AlarmsCardModal
                                    alarms={alarmsPerDay.length === 0 ? alarms : alarmsPerDay}
                                >
                                </AlarmsCardModal>
                                :
                                <></>
                            }
                        </div>
                        {openModalMap === true ?
                            <MapModal
                                open={openModalMap}
                                handleOnClose={handleOnCloseMapModal}
                                latlngData={latlngData}
                            />
                            :
                            <></>
                        }

                    </Modal>
                ) : (

                    <Dialog
                        onClose={handleOnClose}
                        open={open} maxWidth="lg"
                        fullScreen height={'100%'}
                        type={'farm'}
                        disableBackdropTransition
                        disableEscapeKeyDown
                        TransitionComponent={Fade}
                        TransitionProps={{ timeout: 0 }}
                    >

                        <div>
                            {loadingSensorData === false ?
                                <Grid container sx={{ minHeight: '100%' }}>
                                    <div className={styles.divCardChartPortAndAC} style={{ marginTop: !openAlarms ? '-80px' : '25px', height: !openAlarms ? '25vh' : '10vh' }}>
                                        <LineChartCard
                                            dataToChart={datasPerDay.length === 0 ? dataToChartLine : datasPerDay}
                                            type={"portAndAC"}
                                        />
                                        <div className={styles.closeButton}>
                                            <ThemeProvider theme={themeButton}>
                                                <Button onClick={handleOnClose} size="small" sx={{
                                                    backgroundColor: '#9e9e9e', color: 'black', '&:hover': {
                                                        backgroundColor: 'gray',
                                                    },
                                                }} startIcon={<CloseIcon style={{ marginLeft: '10px', fontSize: '25px', color: '#000000' }} />}>
                                                </Button>
                                            </ThemeProvider>
                                        </div>
                                    </div>



                                    <div className={styles.divCardChart} style={{ height: !openAlarms ? '80vh' : '65vh', marginTop: "-60px" }}>
                                        <div id="legend-container" className={styles.divLegend} style={{ height: '15px' }}>

                                        </div>
                                        <LineChartCard
                                            dataToChart={datasPerDay.length === 0 ? dataToChartLine : datasPerDay}
                                            key={chartKey}
                                            type={"all"}
                                        />
                                    </div>
                                    <Grid container spacing={2} sx={{ marginLeft: '550px' }}>
                                        <Grid item xs={4} sx={{ marginTop: '5px' }}>
                                            <ThemeProvider theme={theme}>
                                                <Button onClick={handleCloseModalAlarms} endIcon={<ExpandLessRoundedIcon />} variant="outlined" color='primary' sx={{
                                                    height: '35px', width: '145px', fontSize: '14px', backgroundColor: '#9e9e9e', color: 'white', '&:hover': {
                                                        backgroundColor: 'gray',
                                                    },
                                                }}>
                                                    ALARMES
                                                </Button>
                                            </ThemeProvider>
                                        </Grid>

                                        <Grid item xs={4} sx={{ marginTop: '5px' }}>
                                            <ThemeProvider theme={mapTheme}>
                                                <Button onClick={(e) => handleOpenModalMap(cardId)} variant="outlined" color='primary' endIcon={<LocationOnRoundedIcon />} sx={{
                                                    height: '35px', width: '145px', fontSize: '12px', backgroundColor: 'rgb(223, 138, 12)', color: 'white', '&:hover': {
                                                        backgroundColor: 'rgba(223, 138, 12, 0.8)',
                                                    },
                                                }}>
                                                    VER NO MAPA
                                                </Button>
                                            </ThemeProvider>
                                        </Grid>

                                    </Grid>
                                    <div style={{ width: "100%" }}>
                                        <Typography
                                            style={{ float: 'right', paddingTop: '5px', marginTop: '-80px', fontSize: '13px', marginRight: '50px' }}
                                            component="span"
                                            variant="body2"
                                        >

                                            Atualizado em {lastUpdateDetails === null ? lastUpdate : lastUpdateDetails}
                                        </Typography>
                                    </div>

                                </Grid>
                                :
                                <CircularProgress
                                    size={80}
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: `${-80 / 2}px`,
                                        marginLeft: `${-80 / 2}px`
                                    }}
                                />
                            }
                            {openAlarms === true ?
                                <AlarmsCardModal
                                    alarms={alarmsPerDay.length === 0 ? alarms : alarmsPerDay}
                                >
                                </AlarmsCardModal>
                                :
                                <></>
                            }
                        </div>
                        {openModalMap === true ?
                            <MapModal
                                open={openModalMap}
                                handleOnClose={handleOnCloseMapModal}
                                latlngData={latlngData}
                            />
                            :
                            <></>
                        }
                    </Dialog>
                )}
        </>




    );
}